import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ role }: { role?: 'SYSTEM_ADMIN' | 'COMPANY_USER' | 'DRIVER' }) {
  const { user, loading } = useAuth(); const location = useLocation();
  if (loading) return <div className="grid min-h-[60vh] place-items-center text-slate-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'SYSTEM_ADMIN' ? '/admin' : user.role === 'COMPANY_USER' ? '/profil' : '/sofor'} replace />;
  return <Outlet />;
}
